/* Asil teması — tek script, kütüphane yok.
   Her parça kendi işaretleyicisini ([data-...]) arar; sayfada yoksa sessizce atlar.
   Hiçbir içerik JS'ye bağımlı değil: script çalışmazsa linkler, formlar ve sepet sayfası normal çalışır. */
(() => {
  const A = window.asil || { routes: {}, strings: {} };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Gizli pencerede localStorage hata verebilir; seçilen yaş sadece kolaylık, kaybolması sorun değil.
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* yok say */ } }
  };

  /* ---------- Çekmeceler (menü, arama, sepet) ---------- */
  // Hepsi native <dialog>: odak tuzağı, Esc ve arka plan tarayıcıdan gelir. Kapanırken kısa bir çıkış animasyonu
  // oynasın diye önce .is-closing eklenir, transition bitince dialog kapanır.
  const openDialog = (d) => {
    if (!d || d.open) return;
    d.classList.remove('is-closing');
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    document.documentElement.classList.add('has-dialog');
  };
  const closeDialog = (d) => {
    if (!d || !d.open) return;
    const done = () => {
      d.classList.remove('is-closing');
      if (d.open) d.close();
      if (!$$('dialog[open]').length) document.documentElement.classList.remove('has-dialog');
    };
    if (reduceMotion) { done(); return; }
    d.classList.add('is-closing');
    const panel = $('[data-dialog-panel]', d) || d;
    let finished = false;
    const finish = () => { if (!finished) { finished = true; done(); } };
    panel.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 260);
  };

  $$('dialog[data-dialog]').forEach((d) => {
    d.addEventListener('click', (e) => {
      if (e.target === d || e.target.closest('[data-dialog-close]')) { e.preventDefault(); closeDialog(d); }
    });
    d.addEventListener('cancel', (e) => { e.preventDefault(); closeDialog(d); });
  });

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-dialog-open]');
    if (!opener) return;
    const d = document.getElementById(opener.dataset.dialogOpen);
    if (!d) return;
    // Sepet sayfasındayken sepet çekmecesi açılmasın, sayfa zaten sepet.
    if (d.id === 'cart-drawer' && document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    $$('dialog[open]').forEach((o) => { if (o !== d) closeDialog(o); });
    openDialog(d);
    const focus = $('[data-autofocus]', d);
    if (focus) setTimeout(() => focus.focus(), 30);
  });

  /* ---------- Üst bar ---------- */
  const announce = $('.announce');
  const setAnnounce = () => document.documentElement.style.setProperty('--announce-h', `${announce ? announce.offsetHeight : 0}px`);
  setAnnounce();
  window.addEventListener('resize', setAnnounce);
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 4);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Masaüstü açılır menüler <details>. Biri açılınca diğerleri kapanır; dışarı tıklayınca ve Esc ile kapanır.
  // Fareyle gelen ziyaretçi için üzerine gelince açılır (dokunmatikte sadece tıklama).
  const drops = $$('[data-nav-drop]');
  const closeDrops = (except) => drops.forEach((d) => { if (d !== except) d.removeAttribute('open'); });
  drops.forEach((d) => {
    let t;
    let byHover = false;
    d.addEventListener('toggle', () => { if (d.open) closeDrops(d); });
    d.addEventListener('mouseenter', () => {
      if (!finePointer.matches) return;
      clearTimeout(t);
      if (!d.open) { byHover = true; d.setAttribute('open', ''); }
    });
    d.addEventListener('mouseleave', () => {
      if (!finePointer.matches) return;
      t = setTimeout(() => { d.removeAttribute('open'); byHover = false; }, 120);
    });
    // Üzerine gelince açılan menüde başlığa tıklamak menüyü kapatmasın.
    $('summary', d).addEventListener('click', (e) => { if (byHover && d.open) { e.preventDefault(); byHover = false; } });
    d.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && d.open) { d.removeAttribute('open'); $('summary', d).focus(); }
    });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('[data-nav-drop]')) closeDrops(); });

  /* ---------- Anlık arama ---------- */
  // Shopify Predictive Search: yazdıkça "predictive-search" bölümü sunucuda işlenip HTML olarak gelir.
  $$('[data-predictive]').forEach((form) => {
    const input = $('input[type="search"]', form);
    const out = $('[data-predictive-results]', form.closest('[data-dialog-panel]') || form.parentElement);
    if (!input || !out || !A.routes.predictive) return;
    let timer;
    let controller;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(() => {
        if (controller) controller.abort();
        controller = new AbortController();
        const url = `${A.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
        fetch(url, { signal: controller.signal })
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-predictive-content]');
            out.innerHTML = fresh ? fresh.innerHTML : '';
          })
          .catch(() => {});
      }, 180);
    });
  });

  /* ---------- Giriş slayt gösterisi ---------- */
  // Kendiliğinden geçiş: fareyle üzerindeyken, klavye odağı içindeyken ya da sekme gizliyken durur.
  // Hareket azaltma açıksa hiç kendiliğinden geçmez. Telefonda parmakla sağa/sola kaydırılır.
  $$('[data-slider]').forEach((slider) => {
    const slides = $$('[data-slide]', slider);
    const dots = $$('[data-slide-to]', slider);
    if (slides.length < 2) return;
    const interval = Number(slider.dataset.interval) || 6000;
    slider.style.setProperty('--interval', `${interval}ms`);
    let index = 0;
    let timer = null;
    let hold = false;
    const go = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, j) => {
        const on = j === index;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        $$('a', s).forEach((a) => { if (on) a.removeAttribute('tabindex'); else a.tabIndex = -1; });
        const img = $('.slide__bg img', s);
        if (on && img) img.loading = 'eager';
      });
      dots.forEach((d, j) => {
        d.setAttribute('aria-selected', String(j === index));
        // İlerleme çubuğu animasyonunu baştan başlat.
        const bar = $('span', d);
        if (bar && j === index) { bar.style.display = 'none'; void bar.offsetWidth; bar.style.display = ''; }
      });
      schedule();
    };
    const schedule = () => {
      clearTimeout(timer);
      if (reduceMotion || hold || document.hidden) return;
      timer = setTimeout(() => go(index + 1), interval);
    };
    const pause = () => { hold = true; slider.classList.add('is-paused'); clearTimeout(timer); };
    const resume = () => { hold = false; slider.classList.remove('is-paused'); schedule(); };
    if (!reduceMotion) slider.classList.add('is-auto');
    dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.slideTo))));
    const prev = $('[data-slide-prev]', slider);
    const next = $('[data-slide-next]', slider);
    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));
    slider.addEventListener('mouseenter', () => { if (finePointer.matches) pause(); });
    slider.addEventListener('mouseleave', () => { if (finePointer.matches) resume(); });
    slider.addEventListener('focusin', pause);
    slider.addEventListener('focusout', (e) => { if (!slider.contains(e.relatedTarget)) resume(); });
    document.addEventListener('visibilitychange', () => (document.hidden ? clearTimeout(timer) : schedule()));
    let startX = null;
    const area = $('.hero__slides', slider);
    area.addEventListener('pointerdown', (e) => { startX = e.clientX; });
    area.addEventListener('pointerup', (e) => {
      if (startX === null) return;
      const dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
    });
    schedule();
  });

  /* ---------- Kayan şeritler ---------- */
  // İçerik iki kez basılı; şerit kendi genişliğinin yarısı kadar kayınca başa döner, boşluk görünmez.
  // Hız metnin uzunluğuna göre: her zaman aynı okuma hızında akar.
  $$('[data-ticker]').forEach((t) => {
    const group = $('.ticker__group, .words__group', t);
    if (!group) return;
    const fits = group.scrollWidth <= t.clientWidth;
    if (t.classList.contains('ticker') && fits) return;
    t.classList.add('is-moving');
    const pxPerSec = Number(t.dataset.speed) || 40;
    t.style.setProperty(t.classList.contains('ticker') ? '--ticker-dur' : '--words-dur', `${Math.round(group.scrollWidth / pxPerSec)}s`);
  });

  /* ---------- Giriş hareketi ---------- */
  // Ekrana aynı anda giren kardeşler 60 ms arayla gelir; uzun listede gecikme 300 ms'yi geçmez.
  const rise = $$('[data-rise], [data-reveal]');
  if (rise.length && 'IntersectionObserver' in window && !reduceMotion) {
    document.documentElement.classList.add('can-rise');
    const io = new IntersectionObserver((entries) => {
      entries.filter((e) => e.isIntersecting).forEach((e, i) => {
        e.target.style.setProperty('--rise-delay', `${Math.min(i * 60, 300)}ms`);
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    rise.forEach((el) => io.observe(el));
  }

  /* ---------- Koleksiyon filtresi ---------- */
  // Kartlar data-ages / data-gender / data-cat / data-price / data-available taşır. Paneldeki her değişiklik
  // ızgarayı anında süzer; seçenek yanlarındaki sayılar diğer seçimlere göre güncellenir (0 olan seçenek soluklaşır).
  // Sıralama da tarayıcıda: sayfa yeniden yüklenmez, seçili filtreler kaybolmaz.
  $$('[data-filter-root]').forEach((bar) => {
    const grid = document.getElementById(bar.dataset.grid);
    const panel = document.querySelector(`[data-filter-panel="${bar.dataset.grid}"]`);
    if (!grid || !panel) return;
    const form = $('[data-filter-form]', panel);
    const items = $$(':scope > li', grid);
    const original = items.slice();
    const openBtn = $('[data-filter-open]', bar);
    const badge = $('[data-filter-badge]', bar);
    const countEl = $('[data-filter-count]', bar);
    const activeEl = bar.nextElementSibling && bar.nextElementSibling.matches('[data-filter-active]') ? bar.nextElementSibling : null;
    const emptyEl = grid.parentElement.querySelector('[data-filter-empty]');
    const applyBtn = $('[data-filter-apply]', panel);
    const sortSel = $('[data-filter-sort]', bar);
    if (openBtn) openBtn.hidden = false;

    const read = () => {
      const fd = new FormData(form);
      return {
        age: fd.getAll('age'),
        gender: fd.getAll('gender'),
        cat: fd.getAll('cat'),
        min: parseFloat(fd.get('min')) || null,
        max: parseFloat(fd.get('max')) || null,
        instock: fd.get('instock') === '1'
      };
    };
    const has = (li, attr, vals) => !vals.length || (li.dataset[attr] || '').split(' ').some((v) => vals.includes(v));
    const match = (li, f, skip) => (skip === 'age' || has(li, 'ages', f.age))
      && (skip === 'gender' || has(li, 'gender', f.gender))
      && (skip === 'cat' || has(li, 'cat', f.cat))
      && (f.min === null || Number(li.dataset.price) >= f.min)
      && (f.max === null || Number(li.dataset.price) <= f.max)
      && (!f.instock || li.dataset.available === 'true');

    const labelOf = (input) => {
      const span = input.parentElement.querySelector('span');
      return span ? span.textContent.trim() : input.value;
    };

    const update = () => {
      const f = read();
      let shown = 0;
      items.forEach((li) => {
        const ok = match(li, f);
        li.hidden = !ok;
        if (ok) shown += 1;
      });
      // Her seçeneğin yanında: o seçenek eklenirse kaç ürün kalır.
      $$('input[type="checkbox"]', form).forEach((input) => {
        const key = input.name === 'age' ? 'ages' : input.name;
        if (!['ages', 'gender', 'cat'].includes(key)) return;
        const n = items.filter((li) => match(li, f, input.name) && (li.dataset[key] || '').split(' ').includes(input.value)).length;
        const label = input.parentElement;
        label.classList.toggle('is-empty', n === 0 && !input.checked);
        const c = $('[data-count]', label);
        if (c) c.textContent = n;
      });
      const active = $$('input:checked', form).length + (f.min !== null ? 1 : 0) + (f.max !== null ? 1 : 0);
      if (badge) { badge.hidden = active === 0; badge.textContent = active; }
      if (countEl) countEl.textContent = A.strings.filterCount.replace('__C__', shown);
      if (applyBtn) applyBtn.textContent = A.strings.filterShow.replace('__C__', shown);
      if (emptyEl) emptyEl.hidden = shown !== 0;
      if (activeEl) {
        const chips = [];
        $$('input:checked', form).forEach((input) => chips.push({ label: labelOf(input), clear: () => { input.checked = false; } }));
        if (f.min !== null || f.max !== null) {
          const minI = form.elements.min;
          const maxI = form.elements.max;
          chips.push({
            label: A.strings.filterPrice.replace('__A__', f.min !== null ? f.min : minI.placeholder).replace('__B__', f.max !== null ? f.max : maxI.placeholder),
            clear: () => { minI.value = ''; maxI.value = ''; }
          });
        }
        activeEl.innerHTML = '';
        chips.forEach((c) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'active-filters__chip';
          b.setAttribute('aria-label', A.strings.filterRemove.replace('__L__', c.label));
          b.innerHTML = `<span></span><svg class="icon icon--sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>`;
          b.firstChild.textContent = c.label;
          b.addEventListener('click', () => { c.clear(); update(); });
          activeEl.appendChild(b);
        });
        if (chips.length > 1) {
          const all = document.createElement('button');
          all.type = 'button';
          all.className = 'link active-filters__clear';
          all.textContent = $('[data-filter-clear]', panel).textContent;
          all.addEventListener('click', clear);
          activeEl.appendChild(all);
        }
        activeEl.hidden = chips.length === 0;
      }
    };
    const clear = () => { form.reset(); update(); };
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', (e) => e.preventDefault());
    $$('[data-filter-clear]').forEach((b) => b.addEventListener('click', clear));

    if (sortSel) {
      sortSel.addEventListener('change', () => {
        const v = sortSel.value;
        const sorted = original.slice();
        const title = (li) => (li.querySelector('.pcard__title') || li).textContent.trim();
        if (v === 'price-asc') sorted.sort((a, b) => a.dataset.price - b.dataset.price);
        if (v === 'price-desc') sorted.sort((a, b) => b.dataset.price - a.dataset.price);
        if (v === 'title') sorted.sort((a, b) => title(a).localeCompare(title(b), 'tr'));
        sorted.forEach((li) => grid.appendChild(li));
      });
    }
    update();
  });

  // "Yaş–boy tablosu" linki kapalı akordeonu açıp ona gider.
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-open-details]');
    if (!a) return;
    const target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    target.open = true;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- Sıralama ---------- */
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));

  /* ---------- Sepet ---------- */
  const cartDrawer = document.getElementById('cart-drawer');
  const setCount = (n, bump) => $$('[data-cart-count]').forEach((el) => {
    const changed = el.textContent !== String(n);
    el.textContent = n;
    el.hidden = n === 0;
    // Sayı değişince sayaç kısa bir "zıplama" yapar: ürünün sepete gittiğini gösteren geri bildirim.
    if (bump && changed && !reduceMotion && el.animate) {
      el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 360, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
    }
  });

  const renderDrawer = (html) => {
    if (!cartDrawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-drawer-content]');
    const current = $('[data-drawer-content]', cartDrawer);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  };

  const changeLine = (line, quantity) => {
    if (cartDrawer) cartDrawer.classList.add('is-busy');
    return fetch(`${A.routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: 'cart-drawer' })
    })
      .then((r) => r.json())
      .then((data) => {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        if (data.sections) renderDrawer(data.sections['cart-drawer']);
        setCount(data.item_count || 0);
      })
      .finally(() => cartDrawer && cartDrawer.classList.remove('is-busy'));
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-qty]');
    if (!btn) return;
    const li = btn.closest('[data-line]');
    if (!li) return;
    e.preventDefault();
    changeLine(Number(li.dataset.line), Math.max(0, Number(btn.dataset.lineQty)));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (!input) return;
    const li = input.closest('[data-line]');
    changeLine(Number(li.dataset.line), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- Ürün galerisi ---------- */
  // Yatay kaydırmalı şerit (telefonda parmakla), küçük resimler ve sayaç. Varyant değişince o varyantın
  // stüdyo fotoğrafına kaydırılır; DOM yeniden sıralanmaz.
  const galleries = new Map();
  $$('[data-gallery]').forEach((g) => {
    const track = $('[data-gallery-track]', g);
    const slides = $$('[data-media-id]', track);
    const thumbs = $$('[data-thumb]', g);
    const counter = $('[data-gallery-count]', g);
    const prev = $('[data-gallery-prev]', g);
    const next = $('[data-gallery-next]', g);
    let index = 0;
    const mark = (i) => {
      index = i;
      thumbs.forEach((t, j) => t.setAttribute('aria-current', String(j === i)));
      if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    };
    const go = (i, smooth = true) => {
      const s = slides[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      mark(i);
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    if (prev) prev.addEventListener('click', () => go(Math.max(0, index - 1)));
    if (next) next.addEventListener('click', () => go(Math.min(slides.length - 1, index + 1)));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== index) mark(Math.min(slides.length - 1, Math.max(0, i)));
      });
    }, { passive: true });
    mark(0);
    galleries.set(g, (mediaId) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i > -1) go(i);
    });
  });

  /* ---------- Ürün formu ---------- */
  $$('[data-product]').forEach((root) => {
    const form = $('[data-product-form]', root);
    const jsonEl = $('[data-product-json]', root);
    const data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    const idInput = $('[data-variant-id]', root);
    const priceEl = $('[data-price]', root);
    const addBtn = $('[data-add]', root);
    const addLabel = $('[data-add-label]', root);
    const msg = $('[data-form-msg]', root);
    const gallery = $('[data-gallery]', root);
    const showMedia = gallery ? galleries.get(gallery) : null;

    const selected = () => {
      const positions = [...new Set($$('[data-option]', root).map((i) => i.dataset.option))];
      return positions.map((p) => {
        const checked = root.querySelector(`[data-option="${p}"]:checked`);
        return checked ? checked.value : null;
      });
    };

    const update = () => {
      const opts = selected();
      opts.forEach((v, idx) => {
        const label = root.querySelector(`[data-option-label="${idx}"]`);
        if (label) label.textContent = v;
      });
      const cmLabel = $('[data-cm-label]', root);
      const checkedAge = root.querySelector('[data-cm]:checked');
      if (cmLabel) cmLabel.textContent = checkedAge ? `${A.strings.approx} ${checkedAge.dataset.cm}` : '';
      const variant = data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = A.strings.unavailable;
        return;
      }
      idInput.value = variant.id;
      if (variant.media && showMedia) showMedia(variant.media);
      // Gerçek stok: takip açıksa ve 3 ya da daha az kaldıysa "son N adet" görünür.
      const stockEl = $('[data-stock]', root);
      if (stockEl) {
        const low = variant.available && variant.stock !== null && variant.stock > 0 && variant.stock <= 3;
        stockEl.hidden = !low;
        if (low) stockEl.textContent = A.strings.lowStock.replace('__C__', variant.stock);
      }
      priceEl.innerHTML = variant.price + (variant.compare ? ` <s>${variant.compare}</s>` : '');
      const barPrice = $('[data-buybar-price]', root);
      const barAdd = $('[data-buybar-add]', root);
      if (barPrice) barPrice.textContent = variant.price;
      if (barAdd) barAdd.disabled = !variant.available;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? A.strings.addToCart : A.strings.soldOut;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    // Diğer seçimlerle birlikte stokta olmayan seçenekler üstü çizili görünür (gizlenmez: ziyaretçi bedenin var
    // olduğunu ama tükendiğini görsün).
    const markUnavailable = () => {
      const opts = selected();
      $$('[data-option]', root).forEach((input) => {
        const pos = Number(input.dataset.option) - 1;
        const ok = data.variants.some((v) => v.available && v.options[pos] === input.value
          && v.options.every((o, i) => i === pos || opts[i] === null || o === opts[i]));
        const label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !ok);
      });
    };
    $$('[data-option]', root).forEach((i) => i.addEventListener('change', () => { update(); markUnavailable(); }));
    markUnavailable();

    $$('[data-qty]', root).forEach((b) => b.addEventListener('click', () => {
      const input = form.querySelector('input[name="quantity"]');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qty));
    }));

    // Telefonda asıl buton ekrandan yukarı çıkınca alttaki şerit görünür.
    const bar = $('[data-buybar]', root);
    // Asıl buton ekranın üstünden çıkınca çubuk görünür. Kaydırmaya bağlı ölçüyoruz: hızlı kaydırmada buton
    // görünür alandan hiç geçmeyebilir ve IntersectionObserver o durumda haber vermez.
    if (bar && addBtn) {
      let shown = false;
      let raf;
      const check = () => {
        const show = addBtn.getBoundingClientRect().bottom < 0;
        if (show === shown) return;
        shown = show;
        bar.classList.toggle('is-shown', show);
        bar.setAttribute('aria-hidden', String(!show));
        const b = bar.querySelector('button');
        if (b) b.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(check); }, { passive: true });
      check();
    }

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        addBtn.setAttribute('aria-busy', 'true');
        addBtn.disabled = true;
        const prevLabel = addLabel.textContent;
        addLabel.innerHTML = `<span class="spinner" aria-hidden="true"></span>${A.strings.adding}`;
        const body = new FormData(form);
        body.append('sections', 'cart-drawer');
        let ok = false;
        fetch(`${A.routes.cartAdd}.js`, { method: 'POST', body, headers: { Accept: 'application/json' } })
          .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
          .then(({ ok: good, j }) => {
            if (!good) throw new Error(j.description || j.message || A.strings.error);
            ok = true;
            if (j.sections) renderDrawer(j.sections['cart-drawer']);
            if (msg) msg.textContent = '';
            // Buton bir an yeşile döner ve "Sepete eklendi" der; çekmece de açılır. İkisi aynı anda: kullanıcı
            // hem nereye bastığını hem ürünün nereye gittiğini görür.
            addBtn.classList.add('is-added');
            addLabel.innerHTML = `<svg class="icon icon--sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>${A.strings.added}`;
            return fetch(`${A.routes.cart}.js`, { headers: { Accept: 'application/json' } })
              .then((r) => r.json())
              .then((c) => {
                setCount(c.item_count, true);
                const first = cartDrawer && cartDrawer.querySelector('[data-line]');
                if (first && !reduceMotion) first.classList.add('is-new');
                openDialog(cartDrawer);
              });
          })
          .catch((err) => { if (msg) msg.textContent = err.message || A.strings.error; })
          .finally(() => {
            addBtn.removeAttribute('aria-busy');
            addBtn.disabled = false;
            const reset = () => { addBtn.classList.remove('is-added'); addLabel.textContent = prevLabel; };
            if (ok) setTimeout(reset, 1600); else reset();
          });
      });
    }
  });
})();
